import React from 'react';
import { Card, Divider } from 'antd';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import styles from './analytics-card.module.scss';

/**
 * AnalyticsCard Component
 *
 * Displays a card with a title, a value, and a description for analytics.
 *
 * @param {Object} props - Component properties
 * @param {React.ReactNode} props.title - Card title
 * @param {React.ReactNode} props.value - Main value to display
 * @param {string} props.description - Description or additional information
 */
export const AnalyticsCard = ({ title, value, description }) => {
  return (
    <Card className={styles.card}>
      <div className={styles.cardHeader}>
        <div className={styles.cardTitle}>{title}</div>
      </div>
      <Divider className={styles.divider} />
      <div className={styles.cardContent}>
        <div className={styles.value}>{value}</div>
        <p
          className={styles.description}
          dangerouslySetInnerHTML={description ? { __html: DOMPurify.sanitize(description) } : undefined}
        />
      </div>
    </Card>
  );
};

AnalyticsCard.propTypes = {
  title: PropTypes.node.isRequired,
  value: PropTypes.node.isRequired,
  description: PropTypes.string,
};
